import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Panel from '../../components/common/Panel';
import BackTop from '../../components/common/BackTop';
import PageLayout from '../../components/common/PageLayout';
import DropshipProductCardVariants from '../../components/blocks/DropshipProductCardVariants';
import DropshipProductCardInfo from '../../components/blocks/DropshipProductCardInfo';
import { getDropshipProductsProduct, putDropshipProductsProduct } from '../../store/actions/dropshipProducts';
import Spinner from '../../components/common/Spinner';

function DropshipProductCardPageContainer(props) {
  const { getProduct, product } = props;

  useEffect(() => {
    getProduct();
  }, [getProduct]);

  if (props.isLoading || !product.variants.length) {
    return <Spinner size="large" />;
  }

  const pageTop = (
    <Panel>
      <BackTop text={`${product.title} / ${product.model}`} {...props} />
    </Panel>
  );

  return (
    <PageLayout top={pageTop}>
      <DropshipProductCardInfo product={product} setProduct={props.setProduct} />
      <DropshipProductCardVariants variants={product.variants} />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { product, productIsLoading } = state.dropshipProducts;

  return {
    product,
    isLoading: productIsLoading,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const model = ownProps.match.params.model;
  const supplierId = +ownProps.match.params.supplierId;

  return {
    getProduct: () => dispatch(getDropshipProductsProduct(model, supplierId)),
    setProduct: (data) => dispatch(putDropshipProductsProduct(data, model, supplierId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DropshipProductCardPageContainer);

DropshipProductCardPageContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      model: PropTypes.string.isRequired,
      supplierId: PropTypes.string.isRequired,
    }),
  }).isRequired,
  product: PropTypes.shape({
    variants: PropTypes.array,
  }).isRequired,
  getProduct: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setProduct: PropTypes.func.isRequired,
};
